import React from 'react';
import { FiShield, FiCheckCircle, FiFileText, FiLock } from 'react-icons/fi';

const QUEUE_ITEMS = [
  {
    icon: <FiShield className="text-[#ff6600] text-lg" />,
    iconBg: 'bg-[#ff6600]/10',
    label: 'Security review',
    title: 'SOC 2 Type II report shared',
    badge: 'Resolved',
    badgeCls: 'bg-[#ff6600]/10 text-[#ff6600]',
  },
  {
    icon: <FiCheckCircle className="text-[#0077b5] text-lg" />,
    iconBg: 'bg-[#0077b5]/10',
    label: 'Compliance questionnaire',
    title: 'GDPR checklist — Acme Corp',
    badge: 'Active',
    badgeCls: 'bg-[#0077b5]/10 text-[#0077b5]',
  },
  {
    icon: <FiFileText className="text-[#ff6600] text-lg" />,
    iconBg: 'bg-[#ff6600]/10',
    label: 'NDA request',
    title: 'Mutual NDA — TechFlow Ltd',
    badge: 'In review',
    badgeCls: 'bg-[#ff6600]/10 text-[#ff6600]',
  },
  {
    icon: <FiLock className="text-[#0077b5] text-lg" />,
    iconBg: 'bg-[#0077b5]/10',
    label: 'Audit access',
    title: 'Penetration test logs — pending',
    badge: 'Pending',
    badgeCls: 'bg-[#0077b5]/10 text-[#0077b5]',
  },
];

const GuestThreePartModel = () => (
  <section className="py-24 bg-white">
    <div className="max-w-screen-2xl mx-auto px-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

        {/* Left — Text */}
        <div className="pt-2">
          <div className="inline-block border border-[#919191] text-[#919191] text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-7">
            How It Works
          </div>
          <h2 className="text-4xl font-extrabold text-[#53545a] leading-tight mb-6">
            A seamless three-party trust<br />model that scales
          </h2>
          <p className="text-[#919191] text-base leading-relaxed mb-5">
            Your end customers (Y) submit trust requests — security reviews, questionnaires, NDA requests, or audit access — through our platform. My Risk Shield handles every step: routing, tracking, responding, and resolving.
          </p>
          <p className="text-[#919191] text-base leading-relaxed">
            You (X), our client, get a real-time dashboard showing everything that's happening — with full audit trails and no manual effort required on your end.
          </p>
        </div>

        {/* Right — Live Request Queue */}
        <div className="bg-[#919191]/5 p-2">
          <p className="text-xs font-semibold tracking-widest text-[#919191] uppercase mb-4 px-1">Live Request Queue</p>
          <div className="space-y-3">
            {QUEUE_ITEMS.map((item) => (
              <div key={item.title} className="bg-white  px-5 py-4 flex items-center gap-4 shadow-sm">
                <div className={`w-10 h-10 rounded-full ${item.iconBg} flex items-center justify-center flex-shrink-0`}>
                  {item.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-[#919191] mb-0.5">{item.label}</p>
                  <p className="font-semibold text-[#53545a] text-sm truncate">{item.title}</p>
                </div>
                <span className={`flex-shrink-0 ${item.badgeCls} text-xs font-semibold px-3 py-1 rounded-full`}>
                  {item.badge}
                </span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  </section>
);

export default GuestThreePartModel;
